<template>
    <div class="search-box">
        <div class="search">
            <!-- <select id="keySelect" v-model="selectOption">
                <option v-for="item in selectArr" :value="item.name" :key="item.name">{{ item.value }}</option>
            </select> -->
            <img class="search_img" src="../assets/pubMed/search.png" alt="检索" />
            <input type="text" v-model="searchValue" class="search_val" placeholder="请输入检索词" />
            <!-- <img class="search_img" src="../assets/img/search.png" alt="检索"  /> -->
            <i></i>
            <van-button @click="pubmedSearch()"> 搜索 </van-button>
        </div>
    </div>
</template>
<script>
// import api from '../request/api/pubmedApi'
import api from "../request/api/pubmedApi.js";
export default {
    props: ["type", "searchType", "searchVal"],
    name: "pubmedsearch",
    data() {
        return {
            selectArr: [
                {
                    name: "All",
                    value: "All Fields"
                },
                {
                    name: "Title",
                    value: "Title"
                },
                {
                    name: "Author",
                    value: "Author"
                },
                {
                    name: "Journal",
                    value: "Journal"
                },
                {
                    name: "Volume",
                    value: "Volume"
                },
                {
                    name: "Issue",
                    value: "Issue"
                },
                {
                    name: "Mesh",
                    value: "Mesh"
                }
            ],
            selectOption: this.searchType,
            searchValue: this.searchVal,
            types: this.type,
            searchArr: {}
            // searchType:this.searchType
        };
    },
    mounted() {
        //console.log(this.searchType)
        if (this.$route.query.followId) {
            api.pubMedGetFollowId({ id: this.$route.query.followId, type: 1 }).then((res) => {
                console.log(res);
                if (res.data.pmstr != null) {
                    this.searchValue = res.data.pmstr;
                } else {
                    this.searchValue = res.data.data;
                }
                this.pubmedSearch();
            });
        }
    },
    methods: {
        pubmedSearch() {
            //如果是在首页执行跳转，如果不是直接检索
            //首页
            if (this.types === "index") {
                this.$router.push({ path: "/pubsearchlist", query: { val: this.searchValue, type: this.selectOption, key: "" } });
            } else if (this.types === "search") {
                let formData = new FormData();
                formData.append("alt", "");
                let term = "";
                let key = "";

                if (this.selectOption === "All") {
                    term = this.searchValue;
                } else {
                    term = this.searchValue + "[" + this.selectOption + "]";
                }
                if (this.$route.query.key) {
                    term = "检索式";
                    key = this.$route.query.key.split("?token")[0];
                }
                formData.append("term", term);
                formData.append("exclude", 0);
                formData.append("fenqu", "");
                formData.append("filter", "");
                formData.append("format", "");
                formData.append("impact", "");
                formData.append("jabbr", "");
                formData.append("leftNum", "");
                formData.append("num", "");
                formData.append("page", 1);
                formData.append("pmidListIndex", 0);
                formData.append("pmidListKey", key);
                formData.append("reKey", "");
                formData.append("size", 10);
                formData.append("sjr", "");
                formData.append("sort", "");
                formData.append("total", "");
                api.pubMedSearch(formData).then((res) => {
                    this.searchArr = res.data;
                    this.searchValue = res.data.term;
                });
            }
        }
    },
    watch: {
        searchArr: {
            handler(n) {
                this.$emit("child-say", n);
            },
            //immediate: true,
            deep: true
        },
        selectOption: {
            handler(n) {
                this.$emit("listen-type", n);
            },
            //immediate: true,
            deep: true
        },
        searchValue: {
            handler(n) {
                this.$emit("listen-val", n);
            },
            //immediate: true,
            deep: true
        }
    }
};
</script>

<style scoped>
.search-box {
    padding-top: 1px;
    width: 100%;
    height: 80px;
}

.search {
    position: relative;
    margin: 0.7rem auto;
    width: 90%;
    height: 40px;
    line-height: 40px;
    display: table;
    background: #fff;
    border-radius: 5px;
    border: 1px solid #ddd;
}

#keySelect {
    padding-left: 2%;
    height: 40px;
    width: 23%;
    float: left;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border: none;
}

.search_val {
    padding-left: 2rem;
    padding-right: 3%;
    width: 79%;
    height: 40px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    font-size: 0.9rem;
    border: 0;
}

.search_img {
    position: absolute;
    left: 10px;
    top: 10px;
    width: 22px;
    height: 22px;
    vertical-align: 1px;
}

.search>i{
    height: 0.75rem;
    border-left: 1px solid #e0e0e0;
}
.van-button {
    width: 20%;
    height: 40px;
    vertical-align: top;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    font-size: 0.9rem;
    border: 0;
}
</style>
